const IN_DEV = import.meta.env.DEV || import.meta.env.VITE_E2E === 'true';

export const defaultFlags = {
  switchToClassic: false,
  feedback: false,
  leaveBetaVersion: false,
  avatarSelector: false,
  player: {
    streaks: false,
    quests: false,
    badges: false,
    goals: false,
    focusSelector: false,
    indieProgressReport: IN_DEV,
  },
  modules: {
    new: {
      skillSets: true,
    },
    vif: true,
    wordProblems: {
      defaultToReactView: true,
    },
    wdyk: {
      defaultToReactView: true,
    },
  },
  rankings: {
    top10: false,
  },
  classicRedirect: {
    vif: !IN_DEV,
  },
};

/**
 * This will eventually be configurable, but going with the simplest possible implementation for now.
 */
export function getFlags() {
  return defaultFlags;
}

export function flaggedItems<T>(condition: boolean, items: T[]): T[] {
  return condition ? items : [];
}
